import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import Input from "antd/es/input/Input";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import { useParams, Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Box, Button, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { checkUserPermission } from "../../../common/UserPermission";
import moment from "moment";

const SuspendedReceiving = (props) => {
  const paramObject = useParams();
  const navigate = useNavigate();
  let selectData = [];
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState([]);
  const [selectedReceivingCheckboxIds, setselectedReceivingCheckboxIds] =
    useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [location, setLocation] = useState(0);
  const [status, setStatus] = useState("");
  // console.log("selectedReceivingCheckboxIds", selectedReceivingCheckboxIds);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  //table state

  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  let PERMISSION_DELETE = "delete-customers";

  const handleUnSuspend = () => {
    localStorage.setItem("showTransfer", true);
  };

  // const handleUnSuspend = (pID) => {
  //   // console.log("Pid",pID);
  //   axios
  //     .get(
  //       `${config.receivingBaseUrl}/receivings/listofsuspendrecordByid?id=${pID}`,

  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("res from Suspended Receiving", res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // const handleRowSelected = (e) => {
  //   if (e.selectedRows.length > 0) {
  //     setSelectedRows(e.selectedRows.map((x) => x.ID));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.ID);
  //     console.log(e.selectedRows.map((x) => x.ID));

  //     const selectedReceivingCheckboxIds =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setselectedReceivingCheckboxIds(selectedReceivingCheckboxIds);
  //     console.log(selectedReceivingCheckboxIds);
  //   }
  // };

  // Get all tag data
  const handleListData = (
    globalFilter,
    pagination,
    sorting,
    location,
    status,
    columnFilters
  ) => {
    setLoading(true);
    // const FilterColumnText = {};
    // FilterColumnText.filtercolumntext = columnFilters;

    // let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index+1, 
        // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0 
      };
    });;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    axios
      .get(
        `${config.receivingBaseUrl}/receivings/listofsuspendrecord?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=${pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${globalFilter == undefined ? "" : globalFilter
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&currentorder=${sorting[0]?.desc === undefined
          ? "desc"
          : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&locationid=${location}&status=${status}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("listofsuspendrecord", res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setRowCount(res.data.ResponseData[0]?.TotalRecord);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleListData(globalFilter, pagination, sorting, location, status, columnFilters);
    setLocation(localStorage.getItem("Location"));
    setStatus(
      paramObject.id == 1 ? "Transfer" : paramObject.id == 0 ? "Incoming" : ""
    );
    console.log("loication====>", location);
  }, [globalFilter, pagination, sorting, status, columnFilters]);

  // const handleDeletePopup = (rows) => {
  //   const deleteRequestParam = {
  //     receivingids: pID || selectedReceivingCheckboxIds,
  //   };

  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  // };

  const handleDeletePopup = (rows) => {
    let data = rows.map((el) => el.original.ReceivingId).join(",");

    const deleteRequestParam = {
      receivingids: data,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  // const contextActions = useMemo(() => {
  //     const handleDeletePopup = () => {
  //         const deleteRequestParam = {
  //             deliveriesids: selectedReceivingCheckboxIds,
  //         };
  //         localStorage.setItem(
  //             "DeleteRequestParam",
  //             JSON.stringify(deleteRequestParam)
  //         );
  //     };

  //     return (
  //         <button
  //             type="button"
  //             className="btn btn-success btn-sm pull-left "
  //             data-bs-toggle="modal"
  //             data-bs-target="#UnDeleteConfirmationModal"
  //             onClick={handleDeletePopup}
  //         >
  //             <i className="fa fa-trash fa-sm" /> Un Delete
  //         </button>
  //     );
  // }, [data, selectedRows, toggleCleared]);

  const contextActions = useMemo(() => {
    const handleDeletePopup = () => {
      const deleteRequestParam = {
        receivingids: selectedReceivingCheckboxIds,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  // Table Data
  // const columns = [
  //   {
  //     name: "Sr No",
  //     selector: (row, index) => index + 1,
  //     width: "100px",
  //   },
  //   {
  //     name: "Date",
  //     selector: "Date",
  //     sortable: true,
  //     width: "150px",
  //   },
  //   {
  //     name: " From Location",
  //     selector: "Location",
  //     sortable: true,
  //     width: "200px",
  //   },
  //   {
  //     name: " To Location",
  //     selector: "TransfertoLocation",
  //     sortable: true,
  //     width: "200px",
  //   },
  //   {
  //     name: "Total",
  //     selector: "Total",
  //     sortable: true,
  //     right: true,
  //     width: "200px",
  //   },

  //   {
  //     name: "Comments",
  //     selector: "Comments",
  //     width: "250px",
  //   },
  //   {
  //     name: "Status",
  //     selector: "StatusName",
  //     sortable: true,
  //     width: "150px",
  //   },
  //   {
  //     name: "Receipt",
  //     width: "120px",
  //     cell: (row) => (
  //       <Link to={`/receiving-receipt/${row.ReceivingId}`}>
  //         <button
  //           className="btn btn-sm btn-outline-primary"
  //         >
  //           <i className="fa fa-file"></i>
  //           Receipt
  //         </button>
  //       </Link>
  //     ),
  //   },
  //   {
  //     name: "Action",
  //     width: "100px",
  //     cell: (row) => (
  //       <>
  //         {
  //           row.Status == 1 ? (
  //             <>
  //               <Link className="me-3" to={`/manage-receiving/${row.ReceivingId}`}>
  //                 <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //               </Link>
  //             </>
  //           ):null
  //       }
  //       </>
  //     ),
  //   },
  // ];

  const columns = useMemo(() => [
    {
      header: "Date",
      accessorKey: "Date",
      size :120,
      Cell: ({ row }) => moment(row.original.Date).format("MM/DD/YYYY"),
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "From Location",
      accessorKey: "Location",
      size : 100
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "To Location",
      accessorKey: "TransfertoLocation",
      size : 100
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Qty",
      accessorKey: "Quantity",
      size : 100
    },
    {
      header: "Total",
      accessorKey: "Total",
      size : 100
    },
    {
      header: "Comments",
      accessorKey: "Comments",
    },
    {
      header: "Status",
      accessorKey: "StatusName",
      size : 100,
      Cell: ({ row }) => (
        row.original.StatusName=="Paid"?
      <Box
        // class="text-warning word-break-data"
        // to={`/manage-suppliers/${row.original.SupplierId}`}
        component="span"
        sx={(theme) => ({
          // backgroundColor: '#E8F7F5',
          borderRadius: '0.3rem',
          color: 'var(--success-main-color)',
          maxWidth: '9ch',
          p: '0.3rem',
          fontWeight:"bold"
        })}
      >
        {row.original.StatusName}
      </Box>: 
      row.original.StatusName=="Completed"?
      <Box
      component="span"
      sx={(theme) => ({
        // backgroundColor: 'var(--primary-color-50)',
        borderRadius: '0.3rem',
        color: 'var(--neutral-main-color)',
        maxWidth: '9ch',
        p: '0.3rem',
        fontWeight:"bold"
      })}
    >
       {row.original.StatusName}
       </Box>:
       row.original.StatusName=="Pending"?
       <Box
       component="span"
       sx={(theme) => ({
        //  backgroundColor: '#FEF7E2',
         borderRadius: '0.3rem',
         color: 'var(--error-main-color)',
         maxWidth: '9ch',
         p: '0.3rem',
         fontWeight:"bold"
       })}
     >
        {row.original.StatusName}
        </Box>:
        row.original.StatusName=="Rejected"?
        <Box
        component="span"
        sx={(theme) => ({
          // backgroundColor: '#FBECF0',
          borderRadius: '0.3rem',
          color: '#E5AAB7',
          maxWidth: '9ch',
          p: '0.3rem',
          fontWeight:"bold"
        })}
      >
         {row.original.StatusName}
         </Box>:""
    ),
    },
  ]);

  // function handleCheckboxChange(columnName) {
  //   if (hiddenColumns.includes(columnName)) {
  //     setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
  //   } else {
  //     setHiddenColumns([...hiddenColumns, columnName]);
  //   }
  // }
  // generate new columns according to hiddenColumns data and pass it as datatable column
  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            {paramObject.id == 0 ? (
              <div className="row breadcrumb-position" >
                {/* <h3 className="page-title">Incoming Transfers</h3> */}
                <ul className="breadcrumb">
                  <li
                    className="breadcrumb-item"
                    style={{ marginLeft: "12px" }}
                  >
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li
                    className="breadcrumb-item"
                    style={{ marginLeft: "12px" }}
                  >
                    <Link to="/receiving">Receiving List</Link>
                  </li>
                  <li className="breadcrumb-item active">Incoming Transfers</li>
                </ul>
              </div>
            ) : (
              <div className="row breadcrumb-position" >
                {/* <h3 className="page-title">Transfers Request</h3> */}
                <ul className="breadcrumb">
                  <li
                    className="breadcrumb-item"
                    style={{ marginLeft: "12px" }}
                  >
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/receiving">Receiving List</Link>
                  </li>
                  <li className="breadcrumb-item active">Transfers Request</li>
                </ul>
              </div>
            )}

            {/* <div className="btn-group pull-right ms-2 dropdown">
              <button
                type="button"
                className="btn btn-outline-primary dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ borderRadius: "5px" }}
              >
                <i className="fa fa-cog"></i> &nbsp;
              </button>
              <div className="dropdown-menu">
                {columns.map((column) =>
                  // omit Action column
                  column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                    <div
                      key={column.name.replace(/\s+|-|\/|#/g, "")}
                      className="form-check ms-2 mt-1"
                    >
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`checkbox-${column.name.replace(
                          /\s+|-|\/|#/g,
                          ""
                        )}`}
                        value={column.name.replace(/\s+|-|\/|#/g, "")}
                        checked={
                          !hiddenColumns.includes(
                            column.name.replace(/\s+|-|\/|#/g, "")
                          )
                        } // check all checkboxes which are not include in hiddenColumns
                        onChange={() =>
                          handleCheckboxChange(
                            column.name.replace(/\s+|-|\/|#/g, "")
                          )
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`checkbox-${column.name.replace(
                          /\s+|-|\/|#/g,
                          ""
                        )}`}
                      >
                        {column.name}
                      </label>
                    </div>
                  ) : (
                    ""
                  )
                )}
              </div>
            </div> */}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <div className="col-md-4"></div>
            <div>
              <div className="btn-group pull-right ms-2 ">
                <div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-dark"
                    style={{ borderRadius: "5px", padding: "8px" }}
                    onClick={() => navigate("/receiving")}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row flex-row-reverse">
            {/* <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              />
              {/* <Input.Search placeholder="Search..." className="search-btn form-control form-control-sm" onChange={ChangeFilterText} /> */}
            {/* </div> */}
          </div>

          {/* Customer list */}
          {/* <div className="card"> */}
          {/* <div className="card-body"> */}
          <div>
            {/* <DataTable
                  title={
                    paramObject.id == 1
                      ? "Transfer Location"
                      : paramObject.id == 0
                        ? "Incoming Location"
                        : "Suspended Receiving List"
                  }
                  // Rest of the code...
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  selectableRows
                  sortServer
                  onSort={handleSort}
                  contextActions={contextActions}
                  // contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                /> */}
            <MaterialReactTable
              columns={columns}
              data={data}
              // positionPagination='top'
              enableColumnResizing
              enableGrouping
              enableStickyHeader
              enableStickyFooter
              enableRowSelection
              enableColumnOrdering
              enableRowActions
              positionGlobalFilter="left"
              renderRowActionMenuItems={({ row }) => [
                row.original.Status == 1 ? (
                  <>
                    <MenuItem
                      key="edit"
                      onClick={() =>
                        navigate(
                          `/manage-receiving/${row.original.ReceivingId}`
                        )
                      }
                    >
                      Edit
                    </MenuItem>
                  </>
                ) : null,

                <MenuItem
                  className="confirm-text"
                  to="#"
                  // key="delete"
                  onClick={() =>
                    navigate(`/receiving-receipt/${row.original.ReceivingId}`)
                  }
                >
                  Receipt
                </MenuItem>,
              ]}
              renderTopToolbarCustomActions={({ table }) => (
                <Box
                  sx={{
                    display: "flex",
                    gap: "1rem",
                    p: "0.5rem",
                    flexWrap: "wrap",
                  }}
                >
                  {console.log(table, "tables")}
                  
                  {(table.getIsSomeRowsSelected() ||
                  table.getIsAllRowsSelected()) && (
                    checkUserPermission(PERMISSION_DELETE) ? (
                      <Button
                        size="small"
                        className="btn-secondary"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        onClick={() =>
                          handleDeletePopup(table.getSelectedRowModel().rows)
                        }
                        startIcon={<DeleteIcon />}
                        variant="contained"
                      >
                        Delete
                      </Button>
                    ) : (
                      ""
                    )
                  )}  
                  {/* <Button
                    size="small"
                    onClick={() =>
                      // setPagination({ ...pagination, pageSize: totalRows })
                      setPagination({
                        ...pagination,
                        pageIndex: 0,
                        pageSize: totalRows,
                      })
                    }
                    variant="contained"
                  >
                    Get All Data
                  </Button> */}
                </Box>
              )}
              // rowVirtualizerOptions={{
              //   overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
              //   estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
              // }}
              muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
              initialState={{
                density: "comfortable",
                showGlobalFilter: true,
                expanded: true, //expand all groups by default
                // grouping: [""], //an array of columns to group by by default (can be multiple)
                pagination: { pageIndex: 0, pageSize: 25 },
                // sorting: { id: "Name", desc: false }, //sort by state by default
              }}
              // muiToolbarAlertBannerChipProps={{ color: "primary" }}
              // muiTableContainerProps={{ sx: { maxHeight: 700 } }}


              //For color of each alternative row(Zebra-column)
              muiTableBodyProps={{
                sx: () => ({                    
                  '& tr:nth-of-type(even)': {
                     backgroundColor: 'var(--datatable-row-background-color)'
                     //'rgb(237 237 233 / 63%)'
                  },
                  '& td': {borderRight: '1px solid var(--datatable-row-background-hover-color)',
                lineHeight: '16px',
                  fontWeight: '400',
                  fontSize:'12px',
                  color:'var(--primary-color-800)',
                  fontFamily:'Inter'},
                 
                  '& tr': {lineHeight: '16px',
                  fontWeight: '400',
                  fontSize:'12px',
                  color:'var(--primary-color-800)',
                  fontFamily:'Inter'}
                })
                }}


              muiPaginationProps={{
                rowsPerPageOptions: [25, 50, 100, 300],
              }}


              // For providing color to header of table
              muiTableHeadCellProps={{
                sx: theme => ({
                  background: 'var(--datatable-row-background-color)',//'#e9e9e9',
                  borderRight: '1px solid var(--datatable-row-background-hover-color)',
                  lineHeight: '16px',
                  fontWeight: '500',
                  fontSize:'14px',
                  color:'var(--primary-color-800)',
                  fontFamily:'Inter'
                })
              }}

              // manualFiltering  // for termp comment filteron column
              manualPagination
              manualSorting
              muiToolbarAlertBannerProps={  
                // isError
                // ? {
                //   color: "error",
                //   children: "Error loading data",
                // }
                // : undefined                
                {
                isError: ()=>({color: 'error',
                children: 'Error loading data'
              }),
                sx: theme => ({
                  background: 'var(--datatable-row-background-color)',//'#e9e9e9',
                  lineHeight: '16px',
                  fontWeight: '500',
                  fontSize:'14px',
                  color:'var(--primary-color-800)',
                  fontFamily:'Inter'
                })  
              }}
                  muiSelectCheckboxProps={{ sx: theme => ({                    
                    lineHeight: '16px',
                    fontWeight: '400',
                    fontSize:'12px',
                    color:'var(--prinary-color-800)',
                    fontFamily:'Inter'
                  })
                }}

                muiSelectAllCheckboxProps={{ sx: theme => ({
                 
                  lineHeight: '16px',
                  fontWeight: '400',
                  fontSize:'12px',
                  color:'var(--prinary-color-800)',
                  fontFamily:'Inter'
                })
              }}
              onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
              onGlobalFilterChange={setGlobalFilter}
              onPaginationChange={setPagination}
              onSortingChange={setSorting}
              rowCount={rowCount}
              // enableColumnVirtualization={false}
              // enableColumnVirtualization
              state={{
                // columnFilters, // for termp comment filteron column
                globalFilter,
                isLoading,
                pagination,
                showAlertBanner: isError,
                showProgressBars: isRefetching,
                sorting,
              }}
            />
          </div>
          {/* </div> */}
          {/* </div> */}
        </div>
      </div>

      <DeleteConfirmationModal
        deleteApiUrl={`${config.receivingBaseUrl}/receivings/batchdelete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default SuspendedReceiving;
